import { render, staticRenderFns } from "./NavPillsWidget.vue?vue&type=template&id=a7c333aa&"
import script from "./NavPillsWidget.vue?vue&type=script&lang=js&"
export * from "./NavPillsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7c333aa')) {
      api.createRecord('a7c333aa', component.options)
    } else {
      api.reload('a7c333aa', component.options)
    }
    module.hot.accept("./NavPillsWidget.vue?vue&type=template&id=a7c333aa&", function () {
      api.rerender('a7c333aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/NavPillsWidget.vue"
export default component.exports